<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="`(As of ${dateAsOf})`"
        />
        <b-card>
            <div v-if="!loaded">
                <img src="assets/ajax-loader.gif" style="padding: 10px;" />
            </div>

            <!-- Summary report for each category -->
            <div id="report-body" v-if="loaded" class="w-100">
                <div v-if="params.summary.length > 0">
                    <div id="report-result">
                        <b-table-simple bordered style="margin-bottom: 0px;">
                            <b-thead head-variant="dark">
                                <tr>
                                    <th width="100%" align="left">
                                        <div>
                                            Summary
                                        </div>
                                    </th>
                                </tr>
                            </b-thead>
                        </b-table-simple>
                        <b-table-simple bordered>
                            <b-thead head-variant="light">
                                <tr>
                                    <th style="text-align: left;">
                                        Category
                                    </th>
                                    <th style="text-align: center;">
                                        Total Items
                                    </th>
                                    <th style="text-align: center;">
                                        Avg Unit Price
                                    </th>
                                    <th style="text-align: center;">
                                        Avg Unit Cost
                                    </th>
                                    <th style="text-align: center;">
                                        Avg Profit (Loss)
                                    </th>
                                    <th style="text-align: center;">
                                        Avg Profit (Loss) %
                                    </th>
                                </tr>
                            </b-thead>

                            <tbody>
                                <tr
                                    :key="index"
                                    v-for="(category, index) in params.summary"
                                >
                                    <td align="left">
                                        <a
                                            href="#"
                                            v-scroll-to="
                                                category.category
                                                    ? '#' +
                                                      category.category
                                                          .split(/ |\//)
                                                          .join('_')
                                                    : ''
                                            "
                                        >
                                            {{ category.category }}
                                        </a>
                                    </td>
                                    <td align="center">
                                        {{ category.total_items }}
                                    </td>
                                    <td align="center">
                                        {{ category.avg_unit_price }}
                                    </td>
                                    <td align="center">
                                        {{ category.average_unit_cost }}
                                    </td>
                                    <td align="center">
                                        {{ category.avg_profit_loss }}
                                    </td>
                                    <td align="center">
                                        {{
                                            category.avg_profit_loss_percentage
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                        <br />
                    </div>
                </div>
                <div v-else>
                    <i>No records available</i>
                </div>
            </div>

            <!-- Detail report for each category -->
            <div id="report-body" v-if="loaded" class="w-100">
                <div v-if="params.summary.length > 0">
                    <div
                        id="report-result"
                        :key="index"
                        v-for="(detail, index) in params.detail"
                    >
                        <b-table-simple
                            bordered
                            :id="index ? index.split(/ |\//).join('_') : ''"
                            style="margin-bottom: 0px;"
                        >
                            <b-thead head-variant="dark">
                                <tr>
                                    <th width="100%" align="left">
                                        <div>
                                            {{ index }}
                                        </div>
                                    </th>
                                </tr>
                            </b-thead>
                        </b-table-simple>
                        <b-table-simple bordered>
                            <b-thead head-variant="light">
                                <tr>
                                    <th style="text-align: left; width: 40%;">
                                        Item
                                    </th>
                                    <th style="text-align: center; width: 12%;">
                                        Status
                                    </th>
                                    <th style="text-align: center; width: 12%;">
                                        Unit Price
                                    </th>
                                    <th style="text-align: center; width: 12%;">
                                        Unit Cost
                                    </th>
                                    <th style="text-align: center; width: 12%;">
                                        Profit (Loss)
                                    </th>
                                    <th style="text-align: center; width: 12%;">
                                        Profit (Loss) %
                                    </th>
                                </tr>
                            </b-thead>

                            <tbody>
                                <tr
                                    :key="index"
                                    v-for="(item, index) in detail"
                                >
                                    <td align="left">
                                        <item-name
                                            v-if="
                                                item.item_encoded_id &&
                                                item.status === 'Active'
                                            "
                                            :item="{
                                                name: item.item,
                                                encodedId: item.item_encoded_id
                                            }"
                                        />
                                        <span v-else>
                                            {{ item.item }}
                                        </span>
                                    </td>
                                    <td align="center">
                                        {{ item.status }}
                                    </td>
                                    <td align="center">
                                        {{ item.unit_price }}
                                    </td>
                                    <td align="center">
                                        {{ item.unit_cost }}
                                    </td>
                                    <td align="center">
                                        {{ item.profit_loss }}
                                    </td>
                                    <td align="center">
                                        {{ item.profit_loss_percentage }}
                                    </td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                        <br />
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import moment from "moment";
import ItemName from "@/components/commons/item-name";
import Report from "@/mixins/report.js";
export default {
    components: {
        ItemName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    asOf: moment(),
                    status: 2,
                    category: []
                };
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            meta: "",
            resource: "",
            params: "",
            code: "",
            result: [],
            title: "Profit Margins"
        };
    },
    computed: {
        dateAsOf() {
            if (this.data.asOf) {
                return moment(this.data.asOf)
                    .tz(this._timeZone)
                    .format(this.getDateFormat());
            }
            return null;
        }
    },
    mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.filterDateOption = true;
        self.data.isShowProvider = false;
        self.data.isShowDateTimeRange = false;
        self.data.isShowDateRange = false;
        self.data.isShowItemClass = true;
        self.data.isShowItemCategory = true;
        self.data.isShowAsOf = true;
        self.data.isShowItemStatus = true;

        self._getSetting().then(() => {
            self.data.asOf = moment();
            self.data.status = 2;
            self.data.category = [];
            self.data.itemClass = 0;
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", self.init);
        self.$root.$on("profit-margins:refresh", function () {
            self.init();
        });
    },
    beforeDestroy: function () {
        this.data.isShowItemCategory = false;
        this.data.isShowAsOf = false;
        this.data.isShowItemStatus = false;
        this.data.isShowItemClass = false;
        this.data.isShowDateRange = true;

        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        init(params) {
            let self = this;
            let category = [];
            self.loaded = false;
            self.data.asOf = moment(self.data.asOf);

            if (params) {
                self.data.asOf = moment(params.asOf);
                self.data.status = params.status;
                self.data.category =
                    params.category.length > 0 ? params.category : [];
                self.data.itemClass = params.itemClass;
            }
            category =
                self.data.category.length > 0
                    ? JSON.stringify(self.data.category)
                    : "";
            return this.$http
                .get(
                    process.env.BARRAMUNDI +
                        "report/reports/43?to=" +
                        self.data.asOf.endOf("days").unix() +
                        "&status=" +
                        self.data.status +
                        "&category=" +
                        category +
                        "&item_class=" +
                        self.data.itemClass
                )
                .then(function (response) {
                    self.meta = response.data.response.resource.meta;
                    self.title = self.capitalize(self.meta.title);
                    self.dynamicPageTitle(self.title);
                    self.code = response.data.response.message.code;
                    if (self.code === 200) {
                        self.loaded = true;
                        self.params = {
                            summary: response.data.response.resource.summary,
                            detail: _(response.data.response.resource.detail)
                                .groupBy("category")
                                .value()
                        };
                    }
                });
        }
    }
};
</script>
